export function getWidgetBaseUrl(): string {
  const scripts = Array.from(document.getElementsByTagName("script"));
  const widgetScript = scripts.find(
    (s) => s.src && /\/widget\/upload\.js/.test(s.src)
  );
  if (widgetScript?.src) return new URL(widgetScript.src).origin;
  return window.location.origin;
}
